module.exports = __webpack_public_path__ + "img/icon_cancel.4de194b5.png";